/* eslint-disable newline-before-return */
import { FC } from 'react';

const Component: FC = () => {
  return (
    <>
      <h1>参考リンク</h1>
      <h3>エンジニアドキュメント系</h3>
      <ul>
        <li>
          <a href="https://zenn.dev/boarwell/articles/english-examples">GitHub 英語例文集</a>
        </li>
      </ul>
    </>
  );
};

export default Component;
